module.exports = __webpack_public_path__ + "img/DAY-AND-ROSS.995fcfee.svg";